import { COLORS } from '../../constants';

const styles = theme => {
  // take mobile-first approach to do the styling
  const minSm = theme.breakpoints.up('sm');

  return {
    status: {
      fontSize: '0.75rem',
    },
    status1: {
      color: COLORS.BLUE_LIGHT,
    },
    status2: {
      color: COLORS.YELLOW_DARK,
    },
    status3: {
      color: COLORS.GREEN,
    },
    status4: {
      color: COLORS.GREY_DARK,
    },
    statusDropdown: {
      fontSize: '0.75rem',
      backgroundColor: '#F5F7FA !important',
      minWidth: 100,
      padding: '5px 5px 5px 10px',
      marginLeft: 22,
      borderRadius: 5,

      '& > div > select': {
        backgroundColor: '#F5F7FA',

        '&:focus': {
          backgroundColor: '#F5F7FA',
        },
      },

      [minSm]: {
        color: '#4D4D4D',
        fontSize: '1rem',
        // marginLeft: 0,
      },
    },
    statusDropdownItem: {
      fontSize: '0.75rem',
      [minSm]: {
        color: '#4D4D4D',
        fontSize: '1rem',
      },
    },
  };
};

export default styles;
